export default "__VITE_ASSET__82daf96e__"